module.exports = __webpack_public_path__ + "static/media/minus-icon.9cb2769d.svg";